import { $$ } from '../helpers/shortcuts';

function initializeFormSimulation() {
  $$('#simulate-form-1-button').forEach(($button) => {
    let errorMessageWasAdded = false;
    $button.addEventListener('click', (e) => {
      e.preventDefault && e.preventDefault();
      $$('#simulate-form-1-input').forEach(($input) => {
        if (!errorMessageWasAdded) {
          const $errorMessage = document.createElement('div');
          $errorMessage.classList.add('input-errormessage');
          $errorMessage.textContent =
            'Die von Ihnen eingegebene E-Mail-Adresse ist nicht gültig. Bitte prüfen Sie auf Tippfehler.';
          $input.parentNode.appendChild($errorMessage);
          errorMessageWasAdded = true;
        }

        // set timeout to ensure that transition will be triggered
        setTimeout(() => {
          $input.classList.toggle('invalid');
        }, 10);
      });
    });
  });
}

export function initializeSimulations() {
  initializeFormSimulation();
}
